import {
  Company, GetFirmCompanyCountQuery, ListLegalAssistantIDsQuery,
} from 'API';
import {
  getFirmCompanyCount, listLegalAssistantIDs, updateFirmCompanyCount,
} from 'graphql/customQueries';
import { getCacheWithExpiration, notNullFilter } from 'shared/utilities';
import { client } from 'lib/graphql-client';
import { GraphQLResult } from '@aws-amplify/api';

export const FIRM_RESOURCES_CACHE_KEY = 'firm-resources';

export const FIRM_SLUG = 'meltzer-hellrung';

export const FIRM_COMPANY: Company = {
  /**
   * In each environment in which a firm is created, be sure to use
   * this id and this slug.
   */
  __typename: 'Company',
  id: 'mh',
  name: 'Meltzer Hellrung',
  slug: FIRM_SLUG,
} as Company;

class FirmService {
  incrementCompanyCount = async (): Promise<number> => {
    try {
      const firmCompanyCount = ((await client.graphql({
        query: getFirmCompanyCount,
        variables: { id: FIRM_COMPANY.id },
      })) as GraphQLResult<GetFirmCompanyCountQuery>).data?.getFirm
        ?.companyCount;

      if (firmCompanyCount == null) {
        throw new Error();
      }

      const newFirmCompanyCount = firmCompanyCount + 1;

      await client.graphql({
        query: updateFirmCompanyCount,
        variables: {
          id: FIRM_COMPANY.id,
          companyCount: newFirmCompanyCount,
        },
      });

      return newFirmCompanyCount;
    } catch {
      throw new Error();
    }
  };

  listLegalAssistantIDs = async (): Promise<Array<string>> => {
    try {
      const response = await getCacheWithExpiration(
        'firm-paralegals',
        async () => client.graphql({
          query: listLegalAssistantIDs,
        }),
      ) as GraphQLResult<ListLegalAssistantIDsQuery>;

      if (response.data?.listTeamMembersByPosition?.items) {
        return response.data.listTeamMembersByPosition.items
          .filter(notNullFilter).map((item) => item!.id);
      }

      throw new Error();
    } catch {
      throw new Error();
    }
  };
}

export default new FirmService();
